import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link, Switch } from "react-router-dom";
import { getIpV4PoolById } from "../services/ipv4PoolService";
import IpV4PoolInfo from "./ipV4PoolInfo";
import IpV4Addresses from "./ipV4Addresses";
import { Paper } from "@material-ui/core";
import EngineerRoute from "./common/engineerRoute";

class IpV4Pool extends Component {
  state = {
    pool: {},
  };

  async componentDidMount() {
    const { match } = this.props;
    const poolId = match.params.id;

    try {
      const { data: pool } = await getIpV4PoolById(poolId);
      this.setState({ pool });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  render() {
    const { match } = this.props;
    const poolId = match.params.id;
    return (
      <Paper elevation={3}>
        <div className="card">
          <h5 className="card-header main-color-bg">IpV4/Update Pool</h5>
          <div className="card-body">
            <span className="card-text">
              <Nav variant="tabs" className="customTab">
                <Nav.Item>
                  <Link className="nav-link" to={`/ipv4pools/${poolId}`}>
                    Information
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/ipv4pools/${poolId}/addresses`}>
                    Addresses
                  </Link>
                </Nav.Item>
              </Nav>
              <Switch>
                <EngineerRoute path="/ipv4pools/:id/addresses" render={(props) => <IpV4Addresses {...props} />} />
                <EngineerRoute path="/ipv4pools/:id" render={(props) => <IpV4PoolInfo {...props} />} />
              </Switch>
            </span>
          </div>
        </div>
      </Paper>
    );
  }
}

export default IpV4Pool;
